import React, {useState, useEffect} from 'react'
import PropTypes from 'prop-types'

import {Tab, Dimmer, Loader, Grid, Checkbox, Radio, Label, Item, Header, Segment} from 'semantic-ui-react'
import CreditCardForm from '../CreditCardForm'
import styles from '../bill-card.module.css'
import pdfKSS from '../../docs/KSS.pdf'
import pdfCOHS from '../../docs/COHS.pdf'
import {saveAs} from "file-saver";
import Snackbar from "@material-ui/core/Snackbar";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Helper from "../Helper";
import PageHeader from "../Header";
import Footer from "../Footer";
import axios from "axios";
import {API_BASE} from "../../config/env";

function PaymentPage(props) {

    PaymentPage.propTypes = {
        invoice: PropTypes.object.isRequired,
        corporation: PropTypes.object.isRequired
    }

    const [acceptTermKSS, setAcceptTermKSS] = useState(false);
    const [acceptTermCOHS, setAcceptTermCOHS] = useState(false);
    const [errors, setErrors] = useState({})
    const [invoice, setInvoice] = useState({})
    const [paying, setPaying] = useState(false)
    const [messageOpen, setMessageOpen] = useState(false);
    const [serviceMessage, setServiceMessage] = useState("");
    const [installmentCnt, setInstallmentCnt] = useState("THREE_D_SESSION_ID");
    const [isDonationDo, setIsDonationDo] = useState(false);
    const [isCardMakeInstallment, setIsCardMakeInstallment] = useState(false);
    const { getButtonStyle, isExternalSdk } = Helper();
    const [donationEnable, setDonationEnable] = useState(false);

    useEffect(() => {
        setInvoice(props.location.invoice);
        window.scrollTo(0, 0);
    }, [])

    useEffect(async () => {
      fetchDonationParam().then(result => {
        setDonationEnable(result);
      });
    },[]);

    const fetchDonationParam = async () => {
      const param ='KFO_SDK_DONATION_ENABLE'
      const result = await fetchParam(param);
      if (result.data) {
        let donationParam = result.data.parameterValue == '1' ? true : false
        return donationParam
      }
    };

    const fetchParam = async (param) => {
      const reqParam = {
        paramName: param,
      };
      try {
        const response = await axios.post(`${API_BASE}/getParam`,reqParam,{
          headers: {
            'Content-Type': 'application/json'
          }
        }).catch((error) => console.log(error));
        if (response.status === 200) {
          return response;
        }

        return false;
      } catch (error) {
        return error;
      }
    };

    const panes = [
        {
            menuItem: 'Kredi Kartı ile öde',
            render: () => (
                <Tab.Pane>
                    <CreditCardForm
                        invoice={this.state.invoice}
                        getToken={this.props.getToken}
                    />
                </Tab.Pane>
            )
        }
    ]
    const TabExampleBasicAll = () => <Tab panes={panes}/>

    const handleCheckboxChange = (e, data) => {
        setAcceptTermCOHS(data.checked)
        if (data.checked == true) {
            setErrors({})
        }
    }

    const handleCheckbox2Change = (e, data) => {
        setAcceptTermKSS(data.checked)
        if (data.checked == true) {
            setErrors({})
        }
    }

    const checkAcceptTermCOHS = (e) => {
        const childErrors = {}
        if (acceptTermCOHS == false) {
            childErrors.acceptTermCOHS = e.acceptTermCOHS
            setErrors(childErrors)
        }
    }

    const checkAcceptTermKSS = (e) => {
        const childErrors = {}
        if (acceptTermKSS == false) {
            childErrors.acceptTermKSS = e.acceptTermKSS
            setErrors(childErrors)
        }
    }

    const payingStatusChange = (status) => {
        setPaying(status);
    }

    const installmentStatusChange = (status) => {
        setIsCardMakeInstallment(status);
    }

    const saveFileCOHS = () => {
        saveAs(
            pdfCOHS,
            "çerçeve sözleşmesi.pdf"
        );
    };

    const saveFileKSS = () => {
        saveAs(
            pdfKSS,
            "kart saklama sözleşmesi.pdf"
        );
    };

    const handleClose = (event, reason) => {
        if (reason === "clickaway") {
            return;
        }

        setMessageOpen(false);
    };

    const changeInstallmentCnt = (e, data) => {
        setInstallmentCnt(data.value)
        invoice.customerPaymentMethod = data.value;
        let commission = invoice.commissionList
            .filter((com) => com.custPaymentMethod === data.value)
        invoice.commissionAmount = commission[0].commissionAmount
        invoice.totalAmount = commission[0].totalAmount
        if('THREE_D_SESSION_ID' === data.value) {
            invoice.installmentCount = 0;
        } else if ('THREE_D_SESSION_ID_INST_CNT_2' === data.value){
            invoice.installmentCount = 2;
        } else if ('THREE_D_SESSION_ID_INST_CNT_3' === data.value){
            invoice.installmentCount = 3;
        } else if('SDK_CC' === data.value) {
            invoice.installmentCount = 0;
        } else if ('SDK_CC_INST_CNT_2' === data.value){
            invoice.installmentCount = 2;
        } else if ('SDK_CC_INST_CNT_3' === data.value){
            invoice.installmentCount = 3;
        }
        calculateDonation();
    }

    const handleDonationChange = (e, data) => {
        const isDonationChecked = data.checked;
        setIsDonationDo(isDonationChecked);
        invoice.isDonationDo = isDonationChecked;
        calculateDonation();
    }

    const calculateDonation = () => {
        if (invoice.isDonationDo) {
            let totalAmount = Math.ceil(invoice.totalAmount);
            if (totalAmount == invoice.totalAmount){
                totalAmount = totalAmount +1;
            }
            const yuvarlananTutar = (totalAmount - invoice.totalAmount);
            invoice.totalAmount = totalAmount.toFixed(2);
            invoice.donationAmount = yuvarlananTutar.toFixed(2);
            invoice.vendorDonatId = 1;
            invoice.donationId = 1;
        } else {
            let commission = invoice.commissionList
                .filter((com) => com.custPaymentMethod === invoice.customerPaymentMethod)
            invoice.commissionAmount = commission[0].commissionAmount
            invoice.totalAmount = commission[0].totalAmount
            invoice.donationAmount = null;
            invoice.vendorDonatId = null;
            invoice.donationId = null;
        }

    }


    return (
      <div>

        <PageHeader className='header' />

        <div className={styles.ana_div} >

          <Dimmer active={paying} inverted>
                <Loader inverted>Ödeme Yapılıyor...</Loader>
          </Dimmer>

          <div className={styles.paymentSummeryTab}>
            <CreditCardForm
              invoice={invoice}
              getToken={props.getToken}
              acceptTermKSS={acceptTermKSS}
              acceptTermCOHS={acceptTermCOHS}
              checkAcceptTermCOHS={checkAcceptTermCOHS}
              checkAcceptTermKSS={checkAcceptTermKSS}
              payingStatusChange={payingStatusChange}
              installmentStatusChange={installmentStatusChange}
              setServiceMessage={setServiceMessage}
              setMessageOpen={setMessageOpen}
            />
          </div>

          <div className={styles.paymentSummery}>

            <h2>İşlem Özeti</h2>

            <table frame="shides" rules="rows">
              <tbody>
              <tr className={styles.tr}>
                <td className={styles.label}>Kurum</td>
                <td className={styles.value}>{invoice.corpName}</td>
              </tr>
              <tr className={styles.tr}>
                <td className={styles.label}>Fatura Ref No</td>
                <td className={styles.value}>{invoice.invoiceRefNo}</td>
              </tr>
              <tr className={styles.tr}>
                <td className={styles.label}>Fatura No</td>
                <td className={styles.value}>{invoice.invoiceNo}</td>
              </tr>
              <tr className={styles.tr}>
                <td className={styles.label}>Tutar</td>
                <td className={styles.value}>{invoice.invoiceAmount}</td>
              </tr>
              <tr className={styles.tr}>
                <td className={styles.label}>Son Ödeme Tarihi</td>
                <td className={styles.value}>{invoice.formattedInvoiceDueDate}</td>
              </tr>
              <tr className={styles.tr}>
                <td className={styles.label}>Hizmet Bedeli</td>
                <td className={styles.value}>{invoice.commissionAmount}</td>
              </tr>
              {invoice.isDonationDo ? (<tr className={styles.tr}>
                <td className={styles.label}>Bağış Tutarı</td>
                <td className={styles.value}>{invoice.donationAmount}</td>
              </tr>) : <></>
              }
              <tr className={styles.tr}>
                <td className={styles.label}>Toplam Tutar</td>
                <td className={styles.value}>{invoice.totalAmount}</td>
              </tr>
              </tbody>
            </table>

            <br/>

            <div className={styles.installmentGrid}>
              <Grid columns='equal' columns={3}>
                { isCardMakeInstallment == false ?
                  (
                      <Radio
                      className={styles.installmentRadio}
                      style={getButtonStyle()}
                      name='radioGroup'
                      value={isExternalSdk() ? 'SDK_CC': 'THREE_D_SESSION_ID' }
                      checked={true}
                      label={'Peşin'}>
                    </Radio>
                  )
                  :
                  (props.location.invoice.commissionList.map((com) => (
                        <Radio
                          className={styles.installmentRadio}
                          style={getButtonStyle()}
                          name='radioGroup'
                          value={com.custPaymentMethod}
                          checked={installmentCnt === com.custPaymentMethod}
                          onChange={changeInstallmentCnt}
                          label={(com.custPaymentMethod === 'THREE_D_SESSION_ID' || com.custPaymentMethod === "SDK_CC") ? 'Peşin' :
                            (com.custPaymentMethod.charAt(com.custPaymentMethod.length - 1) + " Taksit")}>
                        </Radio>
                      )
                    )
                  )
                }
                <Label pointing className={styles.installmentLabel}>
                  World, Bonus, Axess, Paraf kartlara taksit yapılmaktadır.
                </Label>
              </Grid>
            </div>

            <br/>

            { donationEnable &&
              <div className={styles.donationDiv}>
                <Checkbox toggle className={styles.donationDivCheckbox}
                          onChange={(e, data) => handleDonationChange(e, data)}/>
                <Item>
                  <Item.Content>
                    <Item.Header as='a'>Ödemenizi yuvarlayın</Item.Header>
                    <Item.Extra>1 tl’ye kadar olan küsüratı Patiliköy’e mama bağışında bulunmak ister
                      misiniz?</Item.Extra>
                  </Item.Content>
                </Item>
              </div>
            }

            <button form="sessionId" type="submit" className={styles.button} style={getButtonStyle()}>
              Ödeme Yap
            </button>

          </div>

          <Snackbar
            anchorOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
            open={messageOpen}
            autoHideDuration={6000}
            onClose={handleClose}
            message={serviceMessage}
            action={
              <React.Fragment>
                <IconButton
                  size="small"
                  aria-label="close"
                  color="inherit"
                  onClick={handleClose}
                >
                  <CloseIcon fontSize="small"/>
                </IconButton>
              </React.Fragment>
            }
          />
        </div>

        {
          !isExternalSdk() &&
          <div style={{position:"fixed",bottom:0,width:'100%'}}>
            <Segment inverted vertical>
              <Footer/>
            </Segment>
          </div>
        }
      </div>
    )
}

export default PaymentPage

